import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { renderField, RadioButtonGroupRow } from "./components";
import { validateRequired } from "./validation";

const StyledForm = ({ renderValue }) => (
  <form method="post" action="#">
    <fieldset>
      <h3>Details of Company</h3>
      <table>
        <thead>
          <tr>
            <th className="text--left">Name of Company</th>
            <th>Policy No.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="80%" id="RO_CompanyName">
              {renderValue({
                fieldName: "CompanyName",
                fieldFormat: "text",
              })}
            </td>
            <td width="20%" id="RO_PolicyNumber">
              {renderValue({
                fieldName: "PolicyNumber",
                fieldFormat: "text",
              })}
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
    <fieldset>
      <h3>Details of Employee</h3>
      <table>
        <thead>
          <tr>
            <th className="text--left">
              Name as in NRIC / FIN / Passport (please underline surname)
            </th>
            <th>NRIC /FIN/ Passport No.</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="80%" id="RO_EmployeeName">
              {renderValue({
                fieldName: "EmployeeName",
                fieldFormat: "text",
              })}
            </td>
            <td width="20%" id="RO_Identification">
              {renderValue({
                fieldName: "Identification",
                fieldFormat: "text",
              })}
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="border--none">
              <table className="border--none">
                <tbody>
                  <tr>
                    <td width="25%">Nationality</td>
                    <td width="10%">Marital Status</td>
                    <td width="15%">Sex</td>
                    <td width="25%">Date of Birth</td>
                    <td width="15%">Monthly Salary</td>
                    <td width="5%">Height (m)</td>
                    <td width="5%">Weight (kg)</td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name="Nationality"
                        type="text"
                        component={renderField}
                        label="Nationality"
                        validate={[validateRequired]}
                      />
                    </td>
                    <td id="RO_MaritalStatus">
                      {renderValue({
                        fieldName: "MaritalStatus",
                        fieldFormat: "text",
                      })}
                    </td>
                    <td id="RO_Gender">
                      {renderValue({
                        fieldName: "Gender",
                        fieldFormat: "text",
                      })}
                    </td>
                    <td id="RO_BirthDate">
                      {renderValue({
                        fieldName: "BirthDate",
                        fieldFormat: "date",
                      })}
                    </td>
                    <td>
                      <span>S$ _________</span>
                    </td>
                    <td>
                      <Field
                        name="Height"
                        type="text"
                        component={renderField}
                        label="Height"
                        validate={[validateRequired]}
                      />
                    </td>
                    <td>
                      <Field
                        name="Weight"
                        type="text"
                        component={renderField}
                        label="Weight"
                        validate={[validateRequired]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="border--none">
              <table className="border--none">
                <tbody>
                  <tr>
                    <td width="40%">Job Designation</td>
                    <td width="20%">Date of Employment (D/M/Y)</td>
                    <td width="20%">Coverage Effective Date</td>
                    <td width="20%">Tel No. (0) / (Mobile)</td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name="JobTitle"
                        type="text"
                        component={renderField}
                        label="JobTitle"
                        validate={[validateRequired]}
                      />
                    </td>
                    <td id="RO_JoinDate">
                      {renderValue({
                        fieldName: "JoinDate",
                        fieldFormat: "date",
                      })}
                    </td>
                    <td id="RO_EffectiveDate">
                      {renderValue({
                        fieldName: "EffectiveDate",
                        fieldFormat: "date",
                      })}
                    </td>
                    <td>
                      <Field
                        name="ContactNumber"
                        type="text"
                        component={renderField}
                        label="ContactNumber"
                        validate={[validateRequired]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
    <fieldset>
      <h3 className="dep-header">DETAILS OF DEPENDENT(S)</h3>
      <span>(to be completed if dependents are covered)</span>
      <table>
        <thead>
          <tr>
            <th colSpan={2} width="40%">
              Full name as in NRIC /FIN/ Passport
            </th>
            <th width="10%">
              NRIC / FIN /<br />
              Passport No.
            </th>
            <th width="10%">
              Date of Birth
              <br />
              (DD/MM/YYYY)
            </th>
            <th width="10%">
              Sex
              <br />
              (M/F)
            </th>
            <th width="10%">
              Height
              <br />
              (m)
            </th>
            <th width="10%">
              Weight
              <br />
              (kg)
            </th>
            <th width="10%">
              Smoker
              <br />
              (Y/N)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Spouse</td>
            <td id="RO_SpouseName">
              {renderValue({
                fieldName: "SpouseName",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_SpouseIdentification">
              {renderValue({
                fieldName: "SpouseIdentification",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_SpouseBirthDate">
              {renderValue({
                fieldName: "SpouseBirthDate",
                fieldFormat: "date",
                dateFormat: "DD/MM/YYYY",
              })}
            </td>
            <td id="RO_SpouseGender">
              {renderValue({
                fieldName: "SpouseGender",
                fieldFormat: "text",
              })}
            </td>
            <td>
              <Field name="SpouseHeight" type="text" component={renderField} label="SpouseHeight" />
            </td>
            <td>
              <Field name="SpouseWeight" type="text" component={renderField} label="SpouseWeight" />
            </td>
            <td>
              <Field name="SpouseSmoke" type="text" component={renderField} label="SpouseSmoke" />
            </td>
          </tr>
          <tr>
            <td>Child 1</td>
            <td id="RO_FirstChildName">
              {renderValue({
                fieldName: "FirstChildName",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_FirstChildIdentification">
              {renderValue({
                fieldName: "FirstChildIdentification",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_FirstChildBirthDate">
              {renderValue({
                fieldName: "FirstChildBirthDate",
                fieldFormat: "date",
              })}
            </td>
            <td id="RO_FirstChildGender">
              {renderValue({
                fieldName: "FirstChildGender",
                fieldFormat: "text",
              })}
            </td>
            <td>
              <Field
                name="FirstChildHeight"
                type="text"
                component={renderField}
                label="FirstChildHeight"
              />
            </td>
            <td>
              <Field
                name="FirstChildWeight"
                type="text"
                component={renderField}
                label="FirstChildWeight"
              />
            </td>
            <td>
              <Field
                name="FirstChildSmoke"
                type="text"
                component={renderField}
                label="FirstChildSmoke"
              />
            </td>
          </tr>
          <tr>
            <td>Child 2</td>
            <td id="RO_SecondChildName">
              {renderValue({
                fieldName: "SecondChildName",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_SecondChildIdentification">
              {renderValue({
                fieldName: "SecondChildIdentification",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_SecondChildBirthDate">
              {renderValue({
                fieldName: "SecondChildBirthDate",
                fieldFormat: "date",
              })}
            </td>
            <td id="RO_SecondChildGender">
              {renderValue({
                fieldName: "SecondChildGender",
                fieldFormat: "text",
              })}
            </td>
            <td>
              <Field
                name="SecondChildHeight"
                type="text"
                component={renderField}
                label="SecondChildHeight"
              />
            </td>
            <td>
              <Field
                name="SecondChildWeight"
                type="text"
                component={renderField}
                label="SecondChildWeight"
              />
            </td>
            <td>
              <Field
                name="SecondChildSmoke"
                type="text"
                component={renderField}
                label="SecondChildSmoke"
              />
            </td>
          </tr>
          <tr>
            <td>Child 3</td>
            <td id="RO_ThirdChildName">
              {renderValue({
                fieldName: "ThirdChildName",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_ThirdChildIdentification">
              {renderValue({
                fieldName: "ThirdChildIdentification",
                fieldFormat: "text",
              })}
            </td>
            <td id="RO_ThirdChildBirthDate">
              {renderValue({
                fieldName: "ThirdChildBirthDate",
                fieldFormat: "date",
              })}
            </td>
            <td id="RO_ThirdChildGender">
              {renderValue({
                fieldName: "ThirdChildGender",
                fieldFormat: "text",
              })}
            </td>
            <td>
              <Field
                name="ThirdChildHeight"
                type="text"
                component={renderField}
                label="ThirdChildHeight"
              />
            </td>
            <td>
              <Field
                name="ThirdChildWeight"
                type="text"
                component={renderField}
                label="ThirdChildWeight"
              />
            </td>
            <td>
              <Field
                name="ThirdChildSmoke"
                type="text"
                component={renderField}
                label="ThirdChildSmoke"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
    <fieldset>
      <table className="health-declaration border--none">
        <tbody>
          <tr>
            <td className="header-border1" rowSpan={2} />
            <td className="header-border2 text--left" width="50%" rowSpan={2}>
              <h2>Health Declaration</h2>
            </td>
            <td className="highlighted" colSpan={2}>
              Employee
            </td>
            <td className="break" />
            <td className="highlighted" colSpan={2}>
              Spouse
            </td>
            <td className="break" />
            <td className="highlighted" colSpan={2}>
              Child 1
            </td>
            <td className="break" />
            <td className="highlighted" colSpan={2}>
              Child 2
            </td>
            <td className="break" />
            <td className="highlighted" colSpan={2}>
              Child 3
            </td>
          </tr>
          <tr>
            <td className="highlighted">Yes</td>
            <td className="highlighted">No</td>
            <td className="break" />
            <td className="highlighted">Yes</td>
            <td className="highlighted">No</td>
            <td className="break" />
            <td className="highlighted">Yes</td>
            <td className="highlighted">No</td>
            <td className="break" />
            <td className="highlighted">Yes</td>
            <td className="highlighted">No</td>
            <td className="break" />
            <td className="highlighted">Yes</td>
            <td className="highlighted">No</td>
          </tr>
          <RadioButtonGroupRow
            questionDesc="Are you currently engaged in or have you any intention of engaging in military or private flying other than as a passenger travelling solely for transport or engaging in hazardous pursuits such as scuba diving, mountain/rock climbing, free fall parachuting, sky diving, motor racing, etc?"
            questionNumber={1}
            questionId="Adventure"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            validate={["required"]}
          />
          <RadioButtonGroupRow
            questionDesc="Have you ever taken narcotics, any habit forming drugs or ever been treated for drug or alcohol addiction?"
            questionNumber={2}
            questionId="DrugAddiction"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Do you have any health or life insurance application that has been rejected, postponed or accepted at special rates or terms by any insurance company?"
            questionNumber={3}
            questionId="Exclusions"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Have you in the <em>last 3 months</em> had any of the following symptoms for more than one week continuously: fatigue, weight loss, diarrhoea, enlarged nodes or unusual skin lesions?"
            questionNumber={4}
            questionId="WeightLoss"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Have you smoked any cigarettes and / or consume alcohol?"
            questionNumber={5}
            questionId="Smoke"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td />
            <td>
              If so, please advise the following:
              <br /> Smoking: No of stick per day
              <Field
                name="EmpSmokeQuantity"
                type="text"
                component={renderField}
                label="EmpSmokeQuantity"
                validate={[]}
                className="smallinput"
              />
              <br /> Drinking: Type, frequency and amount
              <Field
                name="EmpAlcohol"
                type="text"
                component={renderField}
                label="EmpAlcohol"
                validate={[]}
                className="smallinput"
              />
            </td>
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
          </tr>
          <tr>
            <td>6</td>
            <td>Have you EVER had or been told you had or been treated for:</td>
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
          </tr>
          <RadioButtonGroupRow
            questionDesc="a) Asthma, bronchitis, persistent cough, tuberculosis or respiratory disorder."
            questionId="LungDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="b) Epilepsy, fits, stroke, paralysis, weakness of limb, prolonged headache/giddiness, unconsciousness, nervous breakdown, depression or any other nervous/mental disorders or any disease of the brain?"
            questionId="MentalDisorders"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="c) Gastritis, stomach or duodenal ulcer, blood in stools, fistula, piles or any other stomach or bowel disorders?"
            questionId="BowelDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="d) Blood, protein or sugar in urine, kidney stones, infection or any other disorders of the kidney, bladder or genital organs?"
            questionId="KidneyDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="e) Anaemia, diabetes, thyroid disorders or any other endocrine disorder, cancer, tumor, cyst or growth of any kind?"
            questionId="BloodDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="f) Any form of eye, hearing or speech disorder or disease?"
            questionId="HearingAndSight"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="g) Jaundice, Hepatitis B carrier or any form of hepatitis, liver or gallbladder disorders?"
            questionId="GallbladderDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="h) Slipped disc, gout, arthritis, pain or deformity or disorders of the muscles, spine, limbs or joints or severe injury?"
            questionId="PhysicalInjury"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="i) Raised cholesterol, high blood pressure, heart attack, heart murmur, irregular or fast heart rate, chest discomfort or pain, diseases or any other disorders of the heart, heart valves or blood vessels?"
            questionId="HeartDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="Have you or any of your family members, ever been told to have, received any medical advice, counseling or treatment in connection with sexually transmitted disease, AIDS, AIDS Related Complex or any other AIDS related conditions?"
            questionNumber={7}
            questionId="SexualDisease"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="In the past 5 years, have you attended to any tests such as X ray, ultrasound, CT scan, biopsy, electrocardiogram (ECG), endoscopy, blood or urine test?"
            questionNumber={8}
            questionId="DiagnosisInfo"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Any other illness, disorder, injury, disability, operation or hospitalisation <u>not mentioned above</u>?"
            questionNumber={9}
            questionId="PhysicalDisability"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <RadioButtonGroupRow
            questionDesc="Have either of your natural parents or siblings died or suffered from cancer, heart disease, stroke, high blood pressure, diabetes, kidney disease, mental disorder, dementia, tuberculosis, Down's syndrome or any hereditary disease?"
            questionNumber={10}
            questionId="FamilyHistory"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
          <tr>
            <td />
            <td>
              If yes, please provide full details:
              <br />
              <br />
              <table className="border--default">
                <thead>
                  <tr>
                    <th width="30%">Relationship</th>
                    <th width="35%">Condition / Cause of death</th>
                    <th width="15%">Age at onset</th>
                    <th width="20%">If deceased, age at death</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Field
                        name="FamilyRelationship1"
                        type="text"
                        component={renderField}
                        label="FamilyRelationship1"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyMedicalCondition1"
                        type="text"
                        component={renderField}
                        label="FamilyMedicalCondition1"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyAgeAtDiagnosis1"
                        type="text"
                        component={renderField}
                        label="FamilyAgeAtDiagnosis1"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyAgeAtDeath1"
                        type="text"
                        component={renderField}
                        label="FamilyAgeAtDeath1"
                        validate={[]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name="FamilyRelationship2"
                        type="text"
                        component={renderField}
                        label="FamilyRelationship2"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyMedicalCondition2"
                        type="text"
                        component={renderField}
                        label="FamilyMedicalCondition2"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyAgeAtDiagnosis2"
                        type="text"
                        component={renderField}
                        label="FamilyAgeAtDiagnosis2"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyAgeAtDeath2"
                        type="text"
                        component={renderField}
                        label="FamilyAgeAtDeath2"
                        validate={[]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name="FamilyRelationship3"
                        type="text"
                        component={renderField}
                        label="FamilyRelationship3"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyMedicalCondition3"
                        type="text"
                        component={renderField}
                        label="FamilyMedicalCondition3"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyAgeAtDiagnosis3"
                        type="text"
                        component={renderField}
                        label="FamilyAgeAtDiagnosis3"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="FamilyAgeAtDeath3"
                        type="text"
                        component={renderField}
                        label="FamilyAgeAtDeath3"
                        validate={[]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
          </tr>
          <tr>
            <td>11</td>
            <td>
              <strong>
                <u>For Female insured only</u>
              </strong>
            </td>
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
            <td className="break" />
            <td className="highlighted" colSpan={2} />
          </tr>
          <RadioButtonGroupRow
            questionDesc="a) Have you ever had any abnormal pap smear test or been told by a doctor to have a repeat pap smear within the next 6 months? If yes, advise the date and result of the test and enclose a copy of the result, if available."
            questionId="PapSmear"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="b) Have you had an abnormal mammogram or been advised to have mammogram, ultrasound, biopsy, operation of the breasts, ultrasound of pelvis or attended to any other gynecological investigations?"
            questionId="Gynaecological"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="c) Have you ever consulted a doctor for irregular, painful menstruation or other problems(s) involving the female organs?"
            questionId="MenstruationDisorder"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <RadioButtonGroupRow
            questionDesc="d) Have any of your family members been diagnosed with breast cancer? If yes, please complete the following:"
            questionId="BreastCancer"
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
            className="subitem"
          />
          <tr>
            <td />
            <td className="subitem">
              <table className="border--default" style={{ textIndent: 0 }}>
                <thead>
                  <tr>
                    <th width="30%">Relationship to Insured</th>
                    <th width="25%">Age of Diagnosis</th>
                    <th width="45%">Details of breast involvement (left, right or both)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Field
                        name="EmpBreastCancerFamilyRelation1"
                        type="text"
                        component={renderField}
                        label="EmpBreastCancerFamilyRelation1"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="EmpBreastCancerFamilyAgeDiagnosed1"
                        type="text"
                        component={renderField}
                        label="EmpBreastCancerFamilyAgeDiagnosed1"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="EmpBreastCancerFamilyBreastDetails1"
                        type="text"
                        component={renderField}
                        label="EmpBreastCancerFamilyBreastDetails1"
                        validate={[]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name="EmpBreastCancerFamilyRelation2"
                        type="text"
                        component={renderField}
                        label="EmpBreastCancerFamilyRelation2"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="EmpBreastCancerFamilyAgeDiagnosed2"
                        type="text"
                        component={renderField}
                        label="EmpBreastCancerFamilyAgeDiagnosed2"
                        validate={[]}
                      />
                    </td>
                    <td>
                      <Field
                        name="EmpBreastCancerFamilyBreastDetails2"
                        type="text"
                        component={renderField}
                        label="EmpBreastCancerFamilyBreastDetails2"
                        validate={[]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
            <td className="highlighted" />
            <td className="highlighted" />
            <td className="break" />
          </tr>
          <RadioButtonGroupRow
            questionDesc="e) Are you currently pregnant? If so, how many months?"
            questionId="Pregnant"
            questionInput={{
              type: "text",
              name: "EmpPregnantDurationValue",
            }}
            options={["Yes", "No"]}
            columns={["Emp", "Sp", "Ch1", "Ch2", "Ch3"]}
          />
        </tbody>
      </table>
    </fieldset>
    <fieldset>
      <p>
        {[
          'If any of the above answer is "Yes", please state question number ',
          "and provide details below for each condition as follows:",
        ].join("")}
      </p>
      <table>
        <tbody>
          <tr>
            <td width="3%" className="text--center">
              Qn No.
            </td>
            <td width="22%" className="text--center">
              Name of Insured
            </td>
            <td width="8%" className="text--center">
              Name of condition / Activity
            </td>
            <td width="7%" className="text--center">
              Date of Test /<br />
              Diagnosis
            </td>
            <td width="10%" className="text--center">
              Duration of Illness / injury
            </td>
            <td width="20%" className="text--center">
              Reason for test /<br />
              Result advised /<br />
              Details of treatment{" "}
            </td>
            <td width="20%" className="text--center">
              Name & address of Doctors / Clinics/ Hospitals
            </td>
          </tr>
          <tr>
            <td>
              <Field
                name="MoreInfoSubQNo1"
                type="text"
                component={renderField}
                label="MoreInfoSubQNo1"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoName1"
                type="text"
                component={renderField}
                label="MoreInfoName1"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosis1"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosis1"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosisDate1"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosisDate1"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoIllnessDuration1"
                type="text"
                component={renderField}
                label="MoreInfoIllnessDuration1"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoReason1"
                type="text"
                component={renderField}
                label="MoreInfoReason1"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoMedicalProvider1"
                type="text"
                component={renderField}
                label="MoreInfoMedicalProvider1"
                validate={[]}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Field
                name="MoreInfoSubQNo2"
                type="text"
                component={renderField}
                label="MoreInfoSubQNo2"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoName2"
                type="text"
                component={renderField}
                label="MoreInfoName2"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosis2"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosis2"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosisDate2"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosisDate2"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoIllnessDuration2"
                type="text"
                component={renderField}
                label="MoreInfoIllnessDuration2"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoReason2"
                type="text"
                component={renderField}
                label="MoreInfoReason2"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoMedicalProvider2"
                type="text"
                component={renderField}
                label="MoreInfoMedicalProvider2"
                validate={[]}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Field
                name="MoreInfoSubQNo3"
                type="text"
                component={renderField}
                label="MoreInfoSubQNo3"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoName3"
                type="text"
                component={renderField}
                label="MoreInfoName3"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosis3"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosis3"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosisDate3"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosisDate3"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoIllnessDuration3"
                type="text"
                component={renderField}
                label="MoreInfoIllnessDuration3"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoReason3"
                type="text"
                component={renderField}
                label="MoreInfoReason3"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoMedicalProvider3"
                type="text"
                component={renderField}
                label="MoreInfoMedicalProvider3"
                validate={[]}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Field
                name="MoreInfoSubQNo4"
                type="text"
                component={renderField}
                label="MoreInfoSubQNo4"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoName4"
                type="text"
                component={renderField}
                label="MoreInfoName4"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosis4"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosis4"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosisDate4"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosisDate4"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoIllnessDuration4"
                type="text"
                component={renderField}
                label="MoreInfoIllnessDuration4"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoReason4"
                type="text"
                component={renderField}
                label="MoreInfoReason4"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoMedicalProvider4"
                type="text"
                component={renderField}
                label="MoreInfoMedicalProvider4"
                validate={[]}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Field
                name="MoreInfoSubQNo5"
                type="text"
                component={renderField}
                label="MoreInfoSubQNo5"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoName5"
                type="text"
                component={renderField}
                label="MoreInfoName5"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosis5"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosis5"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoDiagnosisDate5"
                type="text"
                component={renderField}
                label="MoreInfoDiagnosisDate5"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoIllnessDuration5"
                type="text"
                component={renderField}
                label="MoreInfoIllnessDuration5"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoReason5"
                type="text"
                component={renderField}
                label="MoreInfoReason5"
                validate={[]}
              />
            </td>
            <td>
              <Field
                name="MoreInfoMedicalProvider5"
                type="text"
                component={renderField}
                label="MoreInfoMedicalProvider5"
                validate={[]}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </form>
);

StyledForm.propTypes = {
  renderValue: PropTypes.func.isRequired,
};

export default StyledForm;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/StyledForm.js